module.exports = "/_next/static/images/eda72b785a788749c06daf97e39ab8cb-hero-xs.jpg";